import DividerBlock from "./DividerBlock";

const HeaderBlock = ({ block }) => {
  const content = block.content;

  return (
    <>
      <div className="header-block">
        <h1 className="header-block-title">{content.title}</h1>
        {content.subtitle && (
          <h2 className="header-block-subtitle">{content.subtitle}</h2>
        )}
      </div>
      <DividerBlock />
    </>
  );
};

export default HeaderBlock;